import { PayloadAction } from '@reduxjs/toolkit';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { FIELD_PRIMITIVE__base } from '@shared/dto/generation/graph_invoke/_fields/_primitives/_base/FIELD_PRIMITIVE__base';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

interface Payload {
  g_hovered_grid2d_column?: FIELD__base;
  g_hovered_grid2d_row?: FIELD__base;
  g_hovered_grid2d_dimension_from_grid: boolean;
}

const PAYLOAD_DEFAULT = {
  g_hovered_grid2d_column: FIELD_PRIMITIVE__base.CREATE_STUB(),
  g_hovered_grid2d_row: FIELD_PRIMITIVE__base.CREATE_STUB(),
  g_hovered_grid2d_dimension_from_grid: false,
};

export const LOCAL__ui_generation_set_hovered_button_grid2d_dimension = (payload: Payload = PAYLOAD_DEFAULT): PayloadAction<Payload> => ({
  type: ENUM__redux_action.UI_GENERATION_SET_BUTTON_GRID2D_DIMENSION_HOVERED,
  payload,
});

export function INIT_LOCAL__ui_generation_set_hovered_button_grid2d_dimension(state: STATE__ui, action: PayloadAction<Payload>) {
  let { g_hovered_grid2d_column: hovered_column, g_hovered_grid2d_row: hovered_row } = action.payload;

  hovered_row = hovered_row || FIELD_PRIMITIVE__base.CREATE_STUB();
  hovered_column = hovered_column || FIELD_PRIMITIVE__base.CREATE_STUB();

  [state.g_hovered_grid2d_column, state.g_hovered_grid2d_row] = [hovered_column.clone(), hovered_row.clone()];

  state.g_hovered_grid2d_dimension_from_grid = action.payload.g_hovered_grid2d_dimension_from_grid;
}
